import { OurService } from '@/features/consumer/our-service';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(consumer)/_public/our-service')({
  component: OurService,
});
